import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=717706ea"
import script from "@/views/modules/Accounts/js/Account.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Accounts/js/Account.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports